import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,isFunction } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import { deleteTripNote,updateNoteTrip,addNewNoteTrip } from '../../../../store/actions/tripActionCreator';
import NotesIcon from '@material-ui/icons/Notes';
import TextInputState from '../../../components/Inputs/TextInputState';
import { InputAdornment,Grid,Dialog,Button } from '@material-ui/core';
import { DialogTitle, DialogContent, DialogActions } from '../../../components/Dialog/Dialog';
import { Form } from 'react-final-form';
import { trackDwebEvent } from '../../../analytics';
import PaySupplierSideBar from '../../../components/RightSideBar/PaySupplierSideBar';
import SuccessDialog from '../../../components/Verfication/SuccessDialog';
import queryString from "query-string";
import FailureDialog from '../../../components/Verfication/FailureDialog';
import { getPaymentStatus } from '../../../../store/actions/OnlinePaymentActionCreators';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding:"0 24px",
    display: 'flex',
    flexDirection:'row',
    alignItems: 'center',
    backgroundColor:'#fff',
    boxShadow:'none',
    marginTop:16,
    justifyContent:'space-between'
  },
  buttonSendMoney: {
    color: 'white',
    fontWeight: 300,
    backgroundColor: '#0033cc',
    textTransform: 'none',
    paddingLeft: 19,
    paddingRight: 18,
    '&:hover': {
      backgroundColor: '#0033cc',
    },
    borderRadius: 4
  },
  mlV1: {
    marginLeft: 14
  },
  box:{
    width:'100%',
    cursor:'pointer'
  },
  listBox:{
    width:'100%',
    backgroundColor:'#f1f1f3',
    padding:'18px 24px',
    marginTop:8,
    borderRadius:8,
    paddingRight:12,
  },
  icon:{
    fontSize:24,
    color:'#03c',
    cursor:'pointer'
  },
  editIcon:{
    fontSize:16,
    color:'#03c',
    cursor:'pointer'
  },
  addNotes:{
    color:'#03c',
    fontSize:16,
    cursor:'pointer',
    marginLeft:12
  },
  noteBox:{
    //width:'100%',
    padding:'8px 16px',
    cursor:'pointer',
    borderRadius:8,
    border:'1px solid #ddd',
    cursor:'pointer'
  },
  editNotes:{
    color:'#0b1323',
    fontSize:14,
    marginLeft:16,
    fontStyle:'italic'
  },
  titleV1: {
    fontSize: 12,
    color: '#9ea0a5',
    marginBottom: 6,
    fontWeight:600
  },
  inputAdornmentV1: {
    height: '0 !important',
    alignItems: 'baseline'
  },
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  marginV2: {
    marginTop: 16
  },
  marginV3: {
    marginTop: 16,
    marginLeft:11
  },
  title: {
    color: '#9ea0a5',
    fontSize: 12
  },
  formHelperText: {
    color: '#9ea0a5',
    fontSize: 11,
    marginTop: 4,
  },
  marginV1: {
    marginTop: 6,
    width: '100%'
  },
  textV1: {
    marginTop: 6,
    width: '100%',
    "& .MuiOutlinedInput-input": {
      textTransform: 'capitalize',
    },
  },
  brV1: {
    borderRadius: 8
  },
  divFlex: {
    display: 'flex',
    alignItems: 'center',
    color: '#0033cc',
    marginTop: 20,
    letterSpacing: '0.02em',
    fontWeight: 300,
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  divAlign: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20
  },
  addIcon: {
    marginTop: -2,
    fontSize: 15,
    cursor: 'pointer'
  },
  textV2: {
    marginLeft: 4,
    cursor: 'pointer'
  },
  disableCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#efeff2',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3e3f42',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em'
  },
  saveCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#161f34',
    fontSize: 14,
    fontWeight: 300,
    color: 'white',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em',
    '&:hover': {
      backgroundColor: '#161f34',
    }
  },
  eventIcon: {
    color: 'grey'
  },
  textNote:{
    '& .MuiInputBase-root':{
      alignItems:'flex-start'
    }
  }
}));
const JourneyTripNotesCard = (props) => {
  const {selectedTrip,journey,dispatchGetPaymentStatus,updateJourney,user,dispatchUpdateNoteTrip,dispatchAddNoteTrip,dispatchDeleteTripNote} = props;
  const classes = useStyles();
  let history = useHistory();
  let search = window.location.search;
  const params = queryString.parse(search);
  let orderId = params["order_id"];
  const today = new Date();
  let submit;
  let tripDetails = selectedTrip;
  let tripId = tripDetails && tripDetails.id?tripDetails.id:'';
  let tripNote = selectedTrip && selectedTrip.notes && selectedTrip.notes.STARTED && selectedTrip.notes.STARTED[0] ? selectedTrip.notes.STARTED[0]:''
  let hiredTrip = journey && journey.vehicle && journey.vehicle.ownershipType && journey.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorData = hiredTrip && journey && journey.vendor && journey.vendor.vendorId ? journey.vendor : null;
  tripDetails.vendor = vendorData;
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let partyBalance = tripDetails && tripDetails.balanceAmount ? tripDetails.balanceAmount : null;
  let vendorBalance = journey && journey.vendor && journey.vendor.vendorId ? journey.vendor.vendorBalance : null;
  tripDetails.vendorBalance = vendorBalance;
  let vendorSettled = hiredTrip && journey && journey.vendor && journey.vendor.isVendorSettled ? journey.vendor.isVendorSettled : false;
  //const [tripNote,setTripNote] = useState( selectedTrip && selectedTrip.notes && selectedTrip.notes.STARTED && selectedTrip.notes.STARTED[0] ? selectedTrip.notes.STARTED[0] : "")
  const [noteValue, setNoteValue] = useState(tripNote && tripNote.id  && tripNote.note && tripNote.note !='START_IMAGE'  ?  tripNote.note : '');
  const [dataFlag, setDataFlag] = useState(false);
  const [dialogopen, setDialogOpen] = React.useState(false);
  const [paySupplier, setPaySupplier] = useState(false);
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [configInfo, setConfigInfo] = useState({});
  const [mixpanelData, setMixpanelData] = useState({});

  const initialValues = {
    note: noteValue,
  }
  const updateNote = ()=>{
    //setTripNote(selectedTrip && selectedTrip.notes && selectedTrip.notes.STARTED && selectedTrip.notes.STARTED[0] ? selectedTrip.notes.STARTED[0] : "")
  }
  const onDialogOpen = ()=>{
    fetchTripDetails()
    updateNote()
    setNoteValue((tripNote && tripNote.id  && tripNote.note || tripNote.note !='START_IMAGE')  ?  tripNote.note : '')
    setDialogOpen(true)
  }
  const handlePaySupplierSideBarClose = (value) => {
    setPaySupplier(false);
    setMixpanelData(value);
    fetchTripDetails()
  }
  const goToSingleTrip = () => {

    const currentUrl = (window.location.href).split("/");
    const query = (currentUrl[currentUrl.length - 1]).split("?");
    const tripIdValue = query[0];

    history.push({
      pathname: `/trips/view/${journey.id}`,
      state: {
        id: 7,
        tripData: journey,
        tripView: true,
        pageTitle: 'Trip Details',
      }
    });
  }

  const handleSuccessOpen = () => {
    setSuccessCreation(true)
  }

  const handleSuccessClose = () => {
    setSuccessCreation(false)
    goToSingleTrip()
  }

  const handleFailureOpen = () => {
    setFailureCreation(true)
  }

  const handleFailureClose = () => {
    setFailureCreation(false)
    goToSingleTrip()
  }
  useEffect(() => {

    if (user && user.configs && user.configs.online_payments_config) {
      setConfigInfo(user.configs.online_payments_config);
    } else {
      setConfigInfo({});
    }

  }, [user.configs]);
  useEffect(() => {

    if (orderId) {
      dispatchGetPaymentStatus({
        orderId: orderId
      }, (response) => {
        if (response && response.status && response.status.code == 200) {
          setPaySupplier(false);
          if (response.response.message == "Transaction Failed.") {
            handleFailureOpen();
            setTimeout(() => {
              handleFailureClose()
            }, 3000);
          } else {
            handleSuccessOpen();
            setTimeout(() => {
              handleSuccessClose()
            }, 3000);
            trackDwebEvent('Dweb STP Supplier payout successful', {
              trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
              trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
              supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
              supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
              trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
              vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
              vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
              origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
              destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
              supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
              supplier_payout_amount: mixpanelData && mixpanelData.payoutAmount ? mixpanelData.payoutAmount : "",
              bank_account_id: mixpanelData && mixpanelData.bankId ? mixpanelData.bankId : ""
            });
          }
        } else {
          handleFailureOpen();
          setTimeout(() => {
            handleFailureClose()
          }, 3000);
          trackDwebEvent('Dweb STP Supplier payout successful', {
            trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
            trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
            supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
            supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
            trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
            vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
            vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
            origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
            destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
            supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
            supplier_payout_amount: mixpanelData && mixpanelData.payoutAmount ? mixpanelData.payoutAmount : "",
            bank_account_id: mixpanelData && mixpanelData.bankId ? mixpanelData.bankId : "",
            error_response: response && response.response && response.response.message ? response.response.message : ""
          });
        }
      }, () => {
        handleFailureOpen();
        setTimeout(() => {
          handleFailureClose()
        }, 3000);
      })
    }

  }, [
    orderId
  ]);
  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div>
                <div className={classes.titleV1}>Notes</div>
                <TextInputState
                  placeholder="Notes"
                  name="note"
                  variant="outlined"
                  size="small"
                  multiline={true}
                  rows={5}
                  rowsMax={5}
                  className={classes.textNote}
                  onChange={(e) => setNoteValue(e.target.value)}
                  InputProps={{
                    startAdornment: <InputAdornment position="start" className={classes.inputAdornmentV1}> <NotesIcon /></InputAdornment>
                  }}
                />
            </div>
          </>
        ),
      }
    ]
  }
  const validate = values => {

    const errors = {}
    if (values && !values.note) {
      errors.note = "Please enter valid name."
    }
    if (values && values.note) {
      setDataFlag(true);
    } else {
      setDataFlag(false);
    }

    return errors;

  }
  const onSubmit = data => {

    if (tripNote && tripNote.id && noteValue.trim()) {

      dispatchUpdateNoteTrip(
        selectedTrip.id,
        tripNote.id,
        {
          note: noteValue.trim()
        },
        (data) => {
          if (data && data.status && data.status.code == 200) {
            handleClose()

          }
        },
        () => {
        }
      );
    } else if (noteValue.trim()) {

      let notesValue = [];

      notesValue.push({
        note: noteValue.trim(),
        noteReceivedDate: Math.round((today.getTime() / 1000))
      })

      dispatchAddNoteTrip(
        selectedTrip.id,
        {
          notes: notesValue,
          tripStatus: "STARTED",
          fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
          fleet_owner_id: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
          fo_id: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
        },
        (data) => {
          if (data && data.status && data.status.code == 200) {
            handleClose()
          }
        },
        () => {
        }
      )

    } else if (tripNote && tripNote.id && !noteValue.trim()) {

      dispatchDeleteTripNote(
        selectedTrip.id,
        tripNote.id,
        (data) => {
          if (data && data.status && data.status.code == 200) {
            handleClose()
          }
        },
        () => {
        }
      )

    }
  };
  const fetchTripDetails = ()=>{
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleSendMoney = () => {
    setPaySupplier(true);
    trackDwebEvent('Dweb STP Supplier payout initiated', {
      trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
      trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
      supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
      supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
      trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
      vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
      vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
      origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
      destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
      supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : ""
    })
  } 
  const handleClose = (status) => {
    fetchTripDetails()
    setNoteValue('')
    //updateNote()
    setDialogOpen(false)
  };
  return (
    <>
      <Paper component='div' className={classes.card} >
        {(selectedTrip.notes && Object.keys(selectedTrip.notes).length === 0 || tripNote && tripNote.note && tripNote.note =='START_IMAGE' ) && <Box onClick={onDialogOpen} className={classes.box} display={'flex'} alignItems={'center'}>
            <AddIcon className={classes.icon} />
            <Typography className={classes.addNotes}>Notes</Typography>
        </Box>}
        {(selectedTrip.notes && Object.keys(selectedTrip.notes).length != 0 && tripNote && tripNote.note && tripNote.note !='START_IMAGE')&& <Box onClick={onDialogOpen} className={classes.noteBox} display={'flex'} alignItems={'center'}>
            <EditIcon className={classes.editIcon} />
            <Typography className={classes.editNotes}>{tripNote.note?`"${tripNote.note}"`:''}</Typography>
        </Box>}
        {hiredTrip && vendorBalance != 0 && configInfo.supplierPayout && configInfo.supplierPayout.show == 1 &&<Box width={'100%'} justifyContent={'flex-end'} display={'flex'} alignItems={'center'}>
          <Button variant="contained" className={classes.buttonSendMoney} onClick={() => handleSendMoney()} >
            &#8377;<span className={classes.mlV1}>Send Money to Supplier</span>
          </Button>
        </Box> }
      </Paper>
      <div>
      {dialogopen && <Dialog fullWidth={true}
        maxWidth='xs'
        onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogopen}
        classes={{ paperScrollPaper: classes.brV1 }}
      >
        <DialogTitle id="add-party-dialog-title" onClose={handleClose}>
          {tripNote && tripNote.id  && tripNote.note && tripNote.note !='START_IMAGE'  ?
            (
              <span>Edit Notes</span>
            ) : (
              <span>Add Notes</span>
            )
          }
        </DialogTitle>
        <DialogContent dividers>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            id="myForm"
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit
              return (
                <form onSubmit={handleSubmit} noValidate id="myForm">
                  <Grid container alignItems="flex-start">
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                </form>
              )
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button className={!dataFlag ? classes.disableCta : classes.saveCta} type="submit" variant="contained"
            onClick={event => {
              submit(event)
            }}
            disabled={!dataFlag}
          >
            Save Notes
          </Button>
        </DialogActions>
      </Dialog>}
    </div>
    {paySupplier &&
        <PaySupplierSideBar rightSideBarOpen={paySupplier} toggleRightSideBar={handlePaySupplierSideBarClose} tripId={tripId} siderName={"pay-supplier"} calledFromFlow={"singleTrip"} tripDetailSingleTrip={tripDetails} />
      }
      {successCreation && <SuccessDialog open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
      {failureCreation && <FailureDialog open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
    </>
  );
}
const JourneyTripNotesCardWithRouter = withRouter(JourneyTripNotesCard);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateNoteTrip: (tripId, noteId, data, onSuccess, onFailure) => {
    dispatch(updateNoteTrip(tripId, noteId, data, onSuccess, onFailure))
  },
  dispatchAddNoteTrip: (tripId, data, onSuccess, onError) => {
    dispatch(addNewNoteTrip(tripId, data, onSuccess, onError))
  },
  dispatchDeleteTripNote: (tripId, noteId, onSuccess, onError) => {
    dispatch(deleteTripNote(tripId, noteId, onSuccess, onError))
  },
  dispatchGetPaymentStatus: (data, onSuccess, onError) => {
    dispatch(getPaymentStatus(data, onSuccess, onError))
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyTripNotesCardWithRouter);